import React, { useState } from "react";
import { Link } from "react-router-dom";
import styles from "./ResourceUploadPage.module.css";

const ResourceUploadPage = () => {
  const [formData, setFormData] = useState({
    title: "",
    category: "stock-market",
    content: "",
    files: [],
  });

  const categories = [
    { id: "stock-market", name: "주식시황" },
    { id: "lectures", name: "강의자료" },
    { id: "analysis", name: "종목분석" },
    { id: "strategies", name: "투자전략" },
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      files: [...e.target.files],
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // 여기서 API를 통해 서버로 데이터를 전송할 것입니다
    console.log("제출된 데이터:", formData);
    // 성공 시 자료실 목록 페이지로 리다이렉트
    // history.push('/resources');
  };

  return (
    <div className={styles.container}>
      <div className={styles.contentWrapper}>
        <div className={styles.mainContent}>
          <div className={styles.pageHeader}>
            <h1 className={styles.pageTitle}>자료 업로드</h1>
          </div>

          <form className={styles.uploadForm} onSubmit={handleSubmit}>
            <div className={styles.formGroup}>
              <label htmlFor="title" className={styles.label}>
                제목 *
              </label>
              <input
                type="text"
                id="title"
                name="title"
                className={styles.textInput}
                value={formData.title}
                onChange={handleInputChange}
                required
                placeholder="자료의 제목을 입력하세요"
              />
            </div>

            <div className={styles.formGroup}>
              <label htmlFor="category" className={styles.label}>
                카테고리 *
              </label>
              <select
                id="category"
                name="category"
                className={styles.selectInput}
                value={formData.category}
                onChange={handleInputChange}
                required
              >
                {categories.map((category) => (
                  <option key={category.id} value={category.id}>
                    {category.name}
                  </option>
                ))}
              </select>
            </div>

            <div className={styles.formGroup}>
              <label htmlFor="content" className={styles.label}>
                내용 *
              </label>
              <textarea
                id="content"
                name="content"
                className={styles.textareaInput}
                value={formData.content}
                onChange={handleInputChange}
                required
                rows="15"
                placeholder="자료의 내용을 입력하세요. HTML 태그를 사용하여 서식을 적용할 수 있습니다."
              ></textarea>
            </div>

            <div className={styles.formGroup}>
              <label htmlFor="files" className={styles.label}>
                첨부파일
              </label>
              <div className={styles.fileInputContainer}>
                <input
                  type="file"
                  id="files"
                  name="files"
                  className={styles.fileInput}
                  onChange={handleFileChange}
                  multiple
                />
                <div className={styles.fileInputLabel}>파일 선택하기</div>
              </div>
              {formData.files.length > 0 && (
                <div className={styles.selectedFiles}>
                  <p>선택된 파일 ({formData.files.length})</p>
                  <ul className={styles.fileList}>
                    {Array.from(formData.files).map((file, index) => (
                      <li key={index} className={styles.fileItem}>
                        {file.name} ({(file.size / (1024 * 1024)).toFixed(2)}{" "}
                        MB)
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>

            <div className={styles.formActions}>
              <Link to="/resources" className={styles.cancelButton}>
                취소
              </Link>
              <button type="submit" className={styles.submitButton}>
                업로드
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ResourceUploadPage;
